export const GET_POPULER_MOVIES = 'GET_POPULER_MOVIES';
export const GET_GENRE_IDS = "GET_GENRE_IDS";
export const GET_MOVIE_BY_ID = "GET_MOVIE_BY_ID";
export const GET_MOVIE_TOP_RATED = "GET_MOVIE_TOP_RATED";
export const GET_SEARCH_MOVIE = "GET_SEARCH_MOVIE";
export const GET_UPCOMING_MOVIE = "GET_UPCOMING_MOVIE";